import { scopedApi } from '@/session/scopedClients';
import { GLOBAL_SCOPE } from '@/session/scopedTransport';
import { EndpointResponse } from '@/types/endpoints';
import { DashboardAlert } from '@/types/dashboard';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

type RequestParams = {
  all?: boolean;
};

type Response = DashboardAlert[];

const validate = () => {};

export const getAllDashboardAlerts = async (
  { all = false }: RequestParams = {},
  options: ReadRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    validate();

    const params = all ? { all: true } : {};
    const result = await scopedApi(GLOBAL_SCOPE).get<EndpointResponse<Response>>('dashboard_alert', { ...options, params });

    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
